import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AttorneyRightSidebarThreeGridSectionOne from '../../components/attorney-components/AttorneyRightSidebarThreeGridSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const AttorneyRightSidebarThreeGridOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Attorney Right Sidebar Three Grid 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Attorney Right Sidebar Three Grid 1"
        />
        
        <AttorneyRightSidebarThreeGridSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default AttorneyRightSidebarThreeGridOne;